// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.debug-tabs {
  width: 900px;
  background: #D1C1FF;
  border: 1px solid #D8D9DB;
  padding: 4px;
  border-radius: 4px;
}
.debug-tabs ul.debug-tabs-list .first-row, .debug-tabs ul.debug-tabs-list .second-row {
  display: flex;
  align-items: center;
  justify-content: center;
}
.debug-tabs ul.debug-tabs-list .first-row li, .debug-tabs ul.debug-tabs-list .second-row li {
  list-style: none;
  padding: 5px 10px;
}
.debug-tabs ul.debug-tabs-list .first-row li a, .debug-tabs ul.debug-tabs-list .second-row li a {
  text-decoration: none;
  color: #000;
  font-weight: 400;
  font-size: 14px;
}
.debug-tabs ul.debug-tabs-list .first-row li a.active, .debug-tabs ul.debug-tabs-list .second-row li a.active {
  background: #fff;
  border-radius: 1px;
  padding: 8px 16px;
}
.debug-tabs ul.debug-tabs-list .first-row li a:hover, .debug-tabs ul.debug-tabs-list .second-row li a:hover {
  text-decoration: none;
  color: #873eff;
}
.debug-tabs ul.debug-tabs-list .first-row li a:focus, .debug-tabs ul.debug-tabs-list .second-row li a:focus {
  box-shadow: unset;
  outline: unset;
}`, "",{"version":3,"sources":["webpack://./src/pages/SiteHealthInfo/SiteHealthInfo.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;AACJ;AACQ;EAEI,aAAA;EACA,mBAAA;EACA,uBAAA;AAAZ;AAEY;EACI,gBAAA;EACA,iBAAA;AAAhB;AACgB;EACI,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AACpB;AAAoB;EACI,gBAAA;EACA,kBAAA;EACA,iBAAA;AAExB;AACgB;EACI,qBAAA;EACA,cAAA;AACpB;AACgB;EACG,iBAAA;EACA,cAAA;AACnB","sourcesContent":[".debug-tabs {\n    width: 900px;\n    background: #D1C1FF;\n    border: 1px solid #D8D9DB;\n    padding: 4px;\n    border-radius: 4px;\n    ul.debug-tabs-list {\n        .first-row, .second-row {\n            \n            display: flex;\n            align-items: center;\n            justify-content: center;\n           \n            li{\n                list-style: none;\n                padding: 5px 10px;\n                a{\n                    text-decoration: none;\n                    color: #000;\n                    font-weight: 400;\n                    font-size: 14px;\n                    &.active{\n                        background: #fff;\n                        border-radius: 1px;\n                        padding: 8px 16px;\n                    }\n                }\n                a:hover{\n                    text-decoration: none;\n                    color: #873eff;\n                }\n                a:focus{\n                   box-shadow: unset;\n                   outline: unset\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
